import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { CurrentUser } from '@/types/api';

const CurrentUserContext = createContext<CurrentUser | null>(null);

export function CurrentUserProvider({
  user,
  children,
}: {
  user: CurrentUser;
  children: ReactNode;
}) {
  return <CurrentUserContext.Provider value={user}>{children}</CurrentUserContext.Provider>;
}

export function useCurrentUser(): CurrentUser {
  const user = useContext(CurrentUserContext);
  if (!user) throw new Error('useCurrentUser must be used inside <CurrentUserProvider>');
  return user;
}

/**
 * UX-level gate only. Hiding admin controls from viewers keeps the UI honest, but the API
 * is the authorization boundary — every admin endpoint re-checks the caller's role.
 */
export function useIsAdmin(): boolean {
  return useCurrentUser().role === 'admin';
}
